if ($('#app-recycle').length) {
    var camp_li_click = 0;
    var rate_li_click = 0;
    var vend_li_click = 0;
    var ws_vr_li_click = 0;
    var ws_lines_li_click = 0;
    var invoices_li_click = 0;
    var day_li_click = 0;
    var order_rev_li_click = 0;
    var orders_li_click = 0;
    var makegoods_li_click = 0;

    //Advertiser Process
    var app_recycle_advertisers_table = $('#app-recycle-advertiser').DataTable({
        "fnDrawCallback": () => {
            $(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/recycle/advertisers',
            dataSrc: 'data'
        },
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'created_by_name'},//2
            {data: 'created_at_format'},//3
            {data: 'deleted_at_format'},//4
            {data: 'id'},//5

        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log(cellData);
                    var html = ' <div class="checkbox checkbox-danger advertisers_check">' +
                        ' <input class="checkbox input_checkbook_advertisers" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_advertiser[]" ' +
                        'value="' + rowData.id + '"  data-row="' + row + '" >' +
                        '<label for="' + rowData.id + '"> </label></div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 5,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html ='';
                    html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_advertiser" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                    $(td).html(html);
                }
            },
        ],
        "createdRow": function (row, data, dataIndex) {
            $(row).attr('data-daypart-id', data.id);
        }
    });

    $('#select_all_advertisers').on('click', function () {
        $('#app-recycle-advertiser input:checkbox').each(function () {
            $(this).prop('checked', true);
        });

    });
    $('#deselect_all_advertisers').on('click', function () {
        $('#app-recycle-advertiser input:checkbox').each(function () {
            $(this).prop('checked', false);
        });
    });

    $('#app-recycle-advertiser').on('click', '.restore_advertiser', function() {
        var id = $(this).attr('data-id');
        swal({
                title: "Warning!",
                text: "Are you sure to restore the Advertiser?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if(isConfirm) {
                    show_loader();
                    $.ajax({
                        type: 'GET',
                        url: '/recycle/restore/advertiser/'+ id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            $('#app-recycle-advertiser').DataTable().ajax.reload()
                            global_notification('success', 'Advertiser restored...')
                            hide_loader();
                        },
                        error: function (xhr) {
                            hide_loader();
                            ajax_error();
                            debug(xhr.responseText);
                        }
                    });
                }
            });
    });
    $('#restore_selected_advertisers').on('click', function() {
        var selectedItems = [];
        $('.advertisers_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length > 0) {
            var params = {
                advertisers_id: selectedItems
            };
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Selected Advertiser(s)?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: '/recycle/restore/multiple/advertiser',
                            dataType: "json",
                            contentType: "application/json",
                            success: function (data) {
                                $('#app-recycle-advertiser').DataTable().ajax.reload()
                                global_notification('success', 'Advertiser(s) restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        } else {
            swal({
                    title: "Warning!",
                    text: "Please select at least one Advertiser.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {}
                });
        }
    });

    //Daypart Process
    $('#tab_day').on('click', function(){
        if(day_li_click  == 0) {
            var app_recycle_daypart_table = $('#app-recycle-dayparts').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/dayparts',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'abbreviation'},//2
                    {data: 'media_type'},//3
                    {data: 'created_at_format'},//4
                    {data: 'deleted_at_format'},//5
                    {data: 'id'},//6

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger dayparts_check">' +
                                ' <input class="checkbox input_checkbook_dayparts" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_dayparts[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 6,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_daypart" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
            day_li_click ++;
        }

        $('#select_all_daypart').on('click', function () {
            $('#app-recycle-dayparts input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_daypart').on('click', function () {
            $('#app-recycle-dayparts input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-dayparts').on('click', '.restore_daypart', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Daypart?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/daypart/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-dayparts').DataTable().ajax.reload()
                                global_notification('success', 'Daypart restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);

                            }
                        });
                    }
                });
        });
        $('#restore_selected_dayparts').on('click', function () {
            var selectedItems = [];
            $('.dayparts_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    dayparts_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Daypart(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/daypart',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-dayparts').DataTable().ajax.reload()
                                    global_notification('success', 'Daypart restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Daypart.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    //Vendor Process
    $('#tab_vend').on('click', function() {
        if(vend_li_click   == 0) {
            var app_recycle_vendors_table = $('#app-recycle-vendors').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/vendors',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'media_type'},//2
                    {data: 'created_at_format'},//3
                    {data: 'deleted_at_format'},//4
                    {data: 'id'},//5

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger vendors_check">' +
                                ' <input class="checkbox input_checkbook_vendors" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_vendors[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 5,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_vendor" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
            vend_li_click ++;
        }
        $('#select_all_vendors').on('click', function () {
            $('#app-recycle-vendors input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_vendors').on('click', function () {
            $('#app-recycle-vendors input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-vendors').on('click', '.restore_vendor', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Vendor?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/vendor/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-vendors').DataTable().ajax.reload()
                                global_notification('success', 'Vendor restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_vendors').on('click', function () {
            var selectedItems = [];
            $('.vendors_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    vendors_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Vendor(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/vendor',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-vendors').DataTable().ajax.reload()
                                    global_notification('success', 'Vendor(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Vendor.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    //Invoice Process
    $('#tab_inv').on('click', function() {
        if(invoices_li_click == 0) {
            var app_recycle_invoices_table = $('#app-recycle-invoices').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/invoices',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'invoice_number'},//1
                    {data: 'advertiser_name'},//2
                    {data: 'campaign_name'},//3
                    {data: 'station_name'},//4
                    {data: 'inv_type'},//5
                    {data: 'created_at_format'},//6
                    {data: 'deleted_at_format'},//7
                    {data: 'id'},//8

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger invoices_check">' +
                                ' <input class="checkbox input_checkbook_invoices" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_invoices[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '"  data-type="' + rowData.inv_type + '">' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 8,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_invoice" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
            invoices_li_click++;
        }
        else
            $('#app-recycle-invoices').DataTable().ajax.reload()

        $('#select_all_invoices').on('click', function () {
            $('#app-recycle-invoices input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_invoices').on('click', function () {
            $('#app-recycle-invoices input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-invoices').on('click', '.restore_invoice', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Invoice?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/invoice/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-invoices').DataTable().ajax.reload()
                                global_notification('success', 'Invoice restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_invoices').on('click', function () {
            var selectedItemsImp = [];
            var selectedItemsMan = [];
            $('.invoices_check input[type=checkbox]').each(function () {
                if (this.checked) {
                    if ($(this).attr('data-type') == 'Manual') {
                        var id = $(this).val().toString().split('m_');
                        console.log('id ', id);
                        selectedItemsMan.push(id[1]);
                    } else
                        selectedItemsImp.push($(this).val());
                }
            });
            console.log('selectedItemsMan ', selectedItemsMan);
            if (selectedItemsImp.length > 0 || selectedItemsMan.length > 0) {
                var params = {
                    imported_ids: selectedItemsImp,
                    manual_ids: selectedItemsMan,
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Invoices(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/invoices',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-invoices').DataTable().ajax.reload()
                                    global_notification('success', 'Invoice(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Invoice.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    //Campaign Process
    $('#tab_camp').on('click', function() {
        if(camp_li_click == 0) {
            camp_li_click++;
            var app_recycle_campaigns_table = $('#app-recycle-campaign').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/campaigns',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'advertiser_name'},//2
                    {data: 'created_at_format'},//3
                    {data: 'deleted_at_format'},//4
                    {data: 'id'},//5

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger campaigns_check">' +
                                ' <input class="checkbox input_checkbook_campaigns" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_campaigns[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 5,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_campaign" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
        }
        else
            $('#app-recycle-campaign').DataTable().ajax.reload()

        $('#select_all_campaigns').on('click', function () {
            $('#app-recycle-campaign input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_campaigns').on('click', function () {
            $('#app-recycle-campaign input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-campaign').on('click', '.restore_campaign', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Campaign?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/campaign/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-campaign').DataTable().ajax.reload()
                                global_notification('success', 'Campaign restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_campaigns').on('click', function () {
            var selectedItems = [];
            $('.campaigns_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    advertisers_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Campaign(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/campaign',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-campaign').DataTable().ajax.reload()
                                    global_notification('success', 'Campaign(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Campaign.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    //Ws Version Process
    $('#tab_wsv').on('click', function() {
        if(ws_vr_li_click  == 0) {
            var app_recycle_ws_version_table = $('#app-recycle-worksheet-versions').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/worksheet_versions',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'number'},//2
                    {data: 'advertiser_name'},//3
                    {data: 'campaign_name'},//4
                    {data: 'created_at_format'},//5
                    {data: 'deleted_at_format'},//6
                    {data: 'id'},//7

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "visible": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger worksheet_versionss_check">' +
                                ' <input class="checkbox input_checkbook_worksheet_versions" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_worksheet_versions[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 7,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_worksheet_versions" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
            ws_vr_li_click ++;
        }
        else
            $('#app-recycle-worksheet-versions').DataTable().ajax.reload()

        $('#select_all_ws_versions').on('click', function () {
            $('#app-recycle-worksheet-versions input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_ws_versions').on('click', function () {
            $('#app-recycle-worksheet-versions input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });
        $('#app-recycle-worksheet-versions').on('click', '.restore_worksheet_versions', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Worksheet Version?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/ws_version/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-worksheet-versions').DataTable().ajax.reload()
                                global_notification('success', 'Worksheet Version restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
    });

    //Ws Version line Process
    $('#tab_wsv_li').on('click', function() {
        if(ws_lines_li_click == 0) {
            var app_recycle_ws_line_table = $('#app-recycle-worksheet-line').DataTable({
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/worksheet_lines',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'advertiser_name'},//1
                    {data: 'campaign_name'},//2
                    {data: 'wv_number'},//3
                    {data: 'wv_name'},//4
                    {data: 'market'},//5
                    {data: 'line_type'},//6
                    {data: 'deleted_at_format'},//7
                    {data: 'count'},//8
                    {data: 'ids'},//8

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "visible": false,
                    },
                    {
                        "targets": 8,
                        "orderable": false,
                    },
                    {
                        "targets": 9,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            // var html = '';
                            // html = '<div class="row text-center " style=""><div class="btn-group " role="group" >';
                            // html += ' <button class="btn btn-primary btn-outline btn-sm preview_worksheet_lines " type="button" data-mar-name="' + rowData.market + '" data-camp-name="' + rowData.campaign_name + '" data-camp-id="' + rowData.campaign_id + '" data-media="' + rowData.line_type + '" data-id="' + rowData.ids + '"><i class="fa fa-eye"></i> Preview </button> ';
                            // html += ' <button class="btn btn-success btn-outline btn-sm restore_worksheet_lines " type="button"  data-camp-id="' + rowData.campaign_id + '" data-media="' + rowData.line_type + '" data-id="' + rowData.ids + '"><i class="fa fa-check"></i> Restore </button> ';
                            // html += '</div></div>';

                            var html = '<div class="btn-group">\n' +
                                '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                                '                <i class="fa fa-ellipsis-v"></i>\n' +
                                '                <span class="sr-only">Toggle Dropdown</span>\n' +
                                '            </button>\n' +
                                '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                                '                <li class="ms-hover">' + '<button class="preview_worksheet_lines " type="button" data-mar-name="' + rowData.market + '" data-camp-name="' + rowData.campaign_name + '" data-camp-id="' + rowData.campaign_id + '" data-media="' + rowData.line_type + '" data-id="' + rowData.ids + '"><i class="fa fa-eye"></i> Preview </button>' + '</li>\n' +
                                '                <li class="ms-hover">' + '<button class="restore_worksheet_lines " type="button"  data-camp-id="' + rowData.campaign_id + '" data-media="' + rowData.line_type + '" data-id="' + rowData.ids + '"><i class="fa fa-check"></i> Restore </button>' + '</li>\n' +
                                '                <li role="separator" class="divider ms-hover"></li>\n' +
                                '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                            '            </ul>\n' +
                            '        </div>';
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
            ws_lines_li_click ++;
        }
        else
            $('#app-recycle-worksheet-line').DataTable().ajax.reload()

        $('#app-recycle-worksheet-line').on('click', '.preview_worksheet_lines', function () {
            show_loader();
            $('.div_cam_name').html('Campaign:&nbsp;&nbsp; ' + $(this).attr('data-camp-name'));
            $('.div_mar_name').html('Market: &nbsp;&nbsp;' + $(this).attr('data-mar-name'));
            $('.div_media_name').html('Media Type: &nbsp;&nbsp;' + $(this).attr('data-media'));
            var ids = $(this).attr('data-id');
            var media = $(this).attr('data-media');
            var camp_id = $(this).attr('data-camp-id');
            var params = {
                ids: ids,
                media: media,
                camp_id: camp_id,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: '/recycle/display/worksheet_lines',
                dataType: "json",
                contentType: "application/json",
                success: function (data) {
                    var columnDef = [];
                    if (media != 'Radio' && media != 'Television')
                        columnDef = columnDefNoBro;
                    else
                        columnDef = columnDefBroad;

                    gridLines.columnDefs = columnDef;
                    gridLines.rowData = [];
                    gridLines.rowData = data;
                    $('#linesGrid').html("");
                    var gridLinesc = document.querySelector('#linesGrid');
                    var g5 = new agGrid.Grid(gridLinesc, gridLines);
                    if (media == 'Television') {
                        gridLines.columnApi.setColumnVisible('network', true);
                        gridLines.columnApi.setColumnVisible('format', false);
                    }
                    if (media == 'Radio') {
                        gridLines.columnApi.setColumnVisible('network', false);
                        gridLines.columnApi.setColumnVisible('format', true);
                    }
                    if (media == 'Digital')
                        gridLines.columnApi.setColumnVisible('gross_rate', false);
                    else
                        gridLines.columnApi.setColumnVisible('gross_rate', true);

                    $('#displayLines').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        });

        $('#app-recycle-worksheet-line').on('click', '.restore_worksheet_lines', function () {
            var ids = $(this).attr('data-id');
            var media = $(this).attr('data-media');
            var camp_id = $(this).attr('data-camp-id');
            var params = {
                ids: ids,
                media: media,
                camp_id: camp_id,
            };
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Worksheet Line(s)?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'POST',
                            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                            data: JSON.stringify(params),
                            url: '/recycle/restore/worksheet_lines',
                            dataType: "json",
                            contentType: "application/json",
                            success: function (data) {
                                $('#app-recycle-worksheet-line').DataTable().ajax.reload()
                                global_notification('success', 'Worksheet Lines restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
    });

    var columnDefBroad = [
        {
            headerName: "Vendor",
            field: 'vendor_name',
            width: 150,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
        },
        {
            headerName: "Time",
            field: 'time',
            width: 110,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
        },
        {
            headerName: "Days",
            field: 'days',
            width: 80,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
        },
        {
            headerName: "Daypart",
            field: 'daypart',
            width: 90,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Len",
            field: 'len',
            width: 60,
            cellStyle: {'text-align': "center"},
        },
        {
            headerName: "Network",
            field: 'network',
            width: 90,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Format",
            field: 'format',
            width: 90,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Program",
            field: 'program',
            width: 100,
            cellStyle: {'text-align': "left"},
        },

        {
            headerName: "Gross Rate",
            field: 'gross_rate',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Comments",
            field: 'comments',
            width: 200,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Totals Ads",
            field: 'spots',
            width: 90,
            cellStyle: {'text-align': "center"},
            pinned: 'right',
        },
        {
            headerName: "Gross Cost",
            field: 'gross_cost',
            width: 100,
            cellStyle: {'text-align': "right"},
            pinned: 'right',
        },
    ];
    var columnDefNoBro = [
        {
            headerName: "Vendor",
            field: 'vendor_name',
            width: 150,
            cellStyle: {'text-align': "left"},
            pinned: 'left',
        },
        {
            headerName: "Date",
            field: 'date',
            width: 160,
            cellStyle: {'text-align': "left"},

        },
        {
            headerName: "Gross Rate",
            field: 'gross_rate',
            width: 100,
            cellStyle: {'text-align': "right"},
        },

        {
            headerName: "Impressions",
            field: 'impressions',
            width: 100,
            cellStyle: {'text-align': "right"},
        },
        {
            headerName: "Comments",
            field: 'comments',
            width: 200,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Specifications",
            field: 'specifications',
            width: 200,
            cellStyle: {'text-align': "left"},
        },
        {
            headerName: "Ad Count",
            field: 'ad_count',
            width: 90,
            cellStyle: {'text-align': "center"},
            pinned: 'right',
        },
        {
            headerName: "Gross Cost",
            field: 'gross_cost',
            width: 100,
            cellStyle: {'text-align': "right"},
            pinned: 'right',
        },
    ];
    var gridLines = {
        columnDefs: [],
        defaultColDef: {
            suppressToolPanel: true
        },
        toolPanelSuppressValues: true,defaultToolPanel: '',
        rowSelection: 'single',
        suppressRowClickSelection: false,
        enableColResize: true,
        suppressMenuColumnPanel: true,
        suppressTouch: true,
        headerHeight: 20,
        suppressDragLeaveHidesColumns: true,
        enableCellChangeFlash: true,
        rowHeight: 20,
        suppressRowHoverClass: true,
        suppressParentsInRowNodes: true,
        toolPanelSuppressValues: true,
        toolPanelSuppressRowGroups: true,
        groupUseEntireRow: false,
        groupDefaultExpanded: 1,
        marryChildren: true,
        suppressAggFuncInHeader: true,
        enableFilter: true,
        enableSorting: true,
        animateRows: true,
        icons: {
            groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
            groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
            menu: '<i class="fa fa-bars fa-lg"/>',
            sortAscending: '<i class="fa fa-caret-down"/>',
            sortDescending: '<i class="fa fa-caret-up"/>',
            columnMoveMove: '<i class="fa fa-arrows"></i>',
            columnMovePin: '<i class="fa fa-thumb-tack"></i>',
            columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
            columnMoveRight: '<i class="fa fa-arrow-right"></i>',
            columnMoveHide: '<i class="fa fa-remove"/>'
        },

    };

    $('#tab_rate_cards').on('click', function() {
        if(rate_li_click == 0) {
            rate_li_click++;
            var app_recycle_campaigns_table = $('#app-recycle-rate-cards').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/rate-cards',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'name'},//1
                    {data: 'market_name'},//2
                    {data: 'vendor_name'},//3
                    {data: 'created_at_format'},//4
                    {data: 'deleted_at_format'},//5
                    {data: 'id'},//6

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger rate_cards_check">' +
                                ' <input class="checkbox input_checkbook_rate_cards" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_rate_cards[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 6,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_rate_card" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
        }
        else
            $('#app-recycle-rate-cards').DataTable().ajax.reload()

        $('#select_all_rate_cards').on('click', function () {
            $('#app-recycle-rate-cards input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_rate_cards').on('click', function () {
            $('#app-recycle-rate-cards input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-rate-cards').on('click', '.restore_rate_card', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Rate Card?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/rate-card/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-rate-cards').DataTable().ajax.reload()
                                global_notification('success', 'Rate Card restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_rate_cards').on('click', function () {
            var selectedItems = [];
            $('.rate_cards_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    rate_cards_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Rate Card(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/rate-card',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-rate-cards').DataTable().ajax.reload()
                                    global_notification('success', 'Rate Card(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Rate Card.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    $('#tab_order_rev').on('click', function() {
        if(order_rev_li_click == 0) {
            order_rev_li_click++;
            var app_recycle_campaigns_table = $('#app-recycle-order-revisions').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/order-revisions',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'reference_number'},//1
                    {data: 'revision_number'},//2
                    {data: 'agency_name'},//3
                    {data: 'vendor_name'},//4
                    {data: 'created_at_format'},//5
                    {data: 'deleted_at_format'},//6
                    {data: 'id'},//7

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger order_revs_check">' +
                                ' <input class="checkbox input_checkbook_order_revs" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_order_revs[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 7,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_order_rev" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
        }
        else
            $('#app-recycle-order-revisions').DataTable().ajax.reload()

        $('#select_all_order_revs').on('click', function () {
            $('#app-recycle-order-revisions input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_order_revs').on('click', function () {
            $('#app-recycle-order-revisions input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-order-revisions').on('click', '.restore_order_rev', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Buyer Order Revision?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/order-rev/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-order-revisions').DataTable().ajax.reload()
                                global_notification('success', 'Order Revision restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_order_revs').on('click', function () {
            var selectedItems = [];
            $('.order_revs_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    order_revs_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Buyer Order Revision(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/order-rev',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-order-revisions').DataTable().ajax.reload()
                                    global_notification('success', 'Order Revision(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Order Revision.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    $('#tab_orders').on('click', function() {
        if(orders_li_click == 0) {
            orders_li_click++;
            var app_recycle_campaigns_table = $('#app-recycle-orders').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/orders',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'reference_number'},//1
                    {data: 'agency_name'},//2
                    {data: 'vendor_name'},//3
                    {data: 'created_at_format'},//4
                    {data: 'deleted_at_format'},//5
                    {data: 'id'},//6

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger orders_check">' +
                                ' <input class="checkbox input_checkbook_orders" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_orders[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 6,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_order" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
        }
        else
            $('#app-recycle-orders').DataTable().ajax.reload()

        $('#select_all_orders').on('click', function () {
            $('#app-recycle-orders input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_orders').on('click', function () {
            $('#app-recycle-orders input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-orders').on('click', '.restore_order', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Buyer Order?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/order/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-orders').DataTable().ajax.reload()
                                global_notification('success', 'Order restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_orders').on('click', function () {
            var selectedItems = [];
            $('.orders_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    orders_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Buyer Order(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/order',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-orders').DataTable().ajax.reload()
                                    global_notification('success', 'Order(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Order.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });

    $('#tab_makegoods').on('click', function() {
        if(makegoods_li_click == 0) {
            makegoods_li_click++;
            var app_recycle_campaigns_table = $('#app-recycle-makegoods').DataTable({
                "fnDrawCallback": () => {
                    $(function () {
                        $('[data-toggle="tooltip"]').tooltip();
                    });
                },
                "processing": true,
                "serverSide": true,
                ajax: {
                    url: '/recycle/makegoods',
                    dataSrc: 'data'
                },
                columns: [
                    {data: 'id'},//0
                    {data: 'reference_number'},//1
                    {data: 'agency_name'},//2
                    {data: 'vendor_name'},//3
                    {data: 'created_at_format'},//4
                    {data: 'deleted_at_format'},//5
                    {data: 'id'},//6

                ],
                // destroy: true,
                pageLength: user_entries,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            console.log(cellData);
                            var html = ' <div class="checkbox checkbox-danger makegoods_check">' +
                                ' <input class="checkbox input_checkbook_makegoods" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_makegoods[]" ' +
                                'value="' + rowData.id + '"  data-row="' + row + '" >' +
                                '<label for="' + rowData.id + '"> </label></div>';
                            $(td).html(html);
                        }
                    },
                    {
                        "targets": 6,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var html = '';
                            html+= ' <button data-toggle="tooltip" data-original-title="Restore" data-placement="top" class="btn btn-success btn-outline btn-off restore_makegood" type="button"  data-id="'+rowData.id+'"><i class="fa fa-history"></i></button> ' ;
                            $(td).html(html);
                        }
                    },
                ],
                "createdRow": function (row, data, dataIndex) {
                    $(row).attr('data-daypart-id', data.id);
                }
            });
        }
        else
            $('#app-recycle-makegoods').DataTable().ajax.reload()

        $('#select_all_makegoods').on('click', function () {
            $('#app-recycle-makegoods input:checkbox').each(function () {
                $(this).prop('checked', true);
            });

        });
        $('#deselect_all_makegoods').on('click', function () {
            $('#app-recycle-makegoods input:checkbox').each(function () {
                $(this).prop('checked', false);
            });
        });

        $('#app-recycle-makegoods').on('click', '.restore_makegood', function () {
            var id = $(this).attr('data-id');
            swal({
                    title: "Warning!",
                    text: "Are you sure to restore the Buyer Makegood?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        show_loader();
                        $.ajax({
                            type: 'GET',
                            url: '/recycle/restore/makegood/' + id,
                            dataType: 'json',
                            encode: true,
                            success: function (data) {
                                $('#app-recycle-makegoods').DataTable().ajax.reload()
                                global_notification('success', 'Makegood restored...')
                                hide_loader();
                            },
                            error: function (xhr) {
                                hide_loader();
                                ajax_error();
                                debug(xhr.responseText);
                            }
                        });
                    }
                });
        });
        $('#restore_selected_makegoods').on('click', function () {
            var selectedItems = [];
            $('.makegoods_check input[type=checkbox]').each(function () {
                if (this.checked)
                    selectedItems.push($(this).val());
            });
            if (selectedItems.length > 0) {
                var params = {
                    makegoods_id: selectedItems
                };
                swal({
                        title: "Warning!",
                        text: "Are you sure to restore the Selected Buyer Makegood(s)?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            show_loader();
                            $.ajax({
                                type: 'POST',
                                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                                data: JSON.stringify(params),
                                url: '/recycle/restore/multiple/makegood',
                                dataType: "json",
                                contentType: "application/json",
                                success: function (data) {
                                    $('#app-recycle-makegoods').DataTable().ajax.reload()
                                    global_notification('success', 'Makegood(s) restored...')
                                    hide_loader();
                                },
                                error: function (xhr) {
                                    hide_loader();
                                    ajax_error();
                                    debug(xhr.responseText);
                                }
                            });
                        }
                    });
            } else {
                swal({
                        title: "Warning!",
                        text: "Please select at least one Makegood.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }
                    });
            }
        });
    });
}
